/* tslint:disable:import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy
}               from '@angular/core';

import {Logger} from "@/util/logger";

@Component({
  selector: 'admin-footer',
  template: `
    <mat-card>

      <mat-card-content style="display: block; height: 500px; padding-top: 32px; padding-left: 24px;">

        <h2 style="color: white;">Support:</h2>
        <a href="http://www.ironroad.ca" target="_blank"><img src="assets/images/ironroad-logo-clean-white.png" width="150" style="opacity: .47;"></a>
        <a href="http://www.ironroad.ca" target="_blank" style="text-decoration: none; text-underline: none;"><h3 style="color: white;">www.ironroad.ca</h3></a>

      </mat-card-content>

    </mat-card>
  `
})
export class AdminFooter  implements OnInit, OnDestroy {

  /** how the template tells us which section of admin area we are in */
  @Input() section: string;

  /** the sub-title for the header */
  public title: string;

  /** initialize component */
  ngOnInit(): void {

    this.title = this.section;

    Logger.debug(`[AdminFooter] setting up (${this.title})...`);

  }

  /** tear down component */
  ngOnDestroy(): void {

    Logger.debug(`[AdminFooter] destroying (${this.title}).`);

  }

}
